import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React, { useState } from 'react';
import { Alert } from '../shared/Alert.jsx';
import { ChangeErrorAlert } from '../shared/ChangeErrorAlert.jsx';
import { SelectApproverAutocomplete } from '../shared/SelectApproverAutocomplete.jsx';
import { BasePopup, ConfirmButton } from '../shared/BasePopup.jsx';
import { DataGrid } from '@mui/x-data-grid';
import { Checkbox, FormControlLabel, Paper, TextField, Typography, RadioGroup, Radio, Box } from '@mui/material';
import { parse, format } from 'date-fns';
import { SelectAgentAutocomplete } from '../shared/SelectAgentAutocomplete.jsx';
export default class MassChangeChangeApproverPopup extends ReactBrick {
    init($) {
        $.observe('Clear Selected Approver').subscribe(() => {
            $.remove('Selected Approver');
        });
    }

    /**
     * Specify your React function component by overriding this method
     * @param {BrickContext} $
     * @returns {function(object): React.ReactElement}
     */
    static getReactComponent($) {
        const DATE_FORMAT = 'yyyy-MM-dd';

        return (props) => {
            const showDialog = useProperty($, 'Show Dialog') || false;
            const operation = useProperty($, 'Operation') || 'Edit';
            const showSuccessAlert = useProperty($, 'Show Success Alert') || false;
            const showErrorAlert = useProperty($, 'Show Error Alert') || false;
            const errorMessage = $.get('Error Message') || '';

            const selectedApprover = useProperty($, 'Selected Approver');
            const setSelectedApprover = (approverObj) => {
                $.set('Selected Approver', approverObj);
            };

            const typeOptions = [
                { label: 'User', value: 'US' },
                { label: 'Position', value: 'S' },
            ];
            const [type, setType] = useState(typeOptions[0].value);

            const isDelegation = useProperty($, 'Is delegation');
            const delegationFrom = useProperty($, 'Delegation From');
            const delegationTo = useProperty($, 'Delegation To');

            const handleClose = () => {
                $.set('Show Dialog', false);
                $.set('Show Success Alert', false);
                $.set('Show Error Alert', false);
            };

            const handleConfirm = () => {
                handleClose();
                $.trigger('On Confirm');
            };

            if (showDialog) {
                if (operation === 'Edit') {
                    return (
                        <BasePopup
                            title="Change Approver"
                            content={
                                <div>
                                    <div>
                                        <div
                                            className="edit-agent-responsibility-form"
                                            style={{ display: 'flex', flexDirection: 'column' }}
                                        >
                                            <div>
                                                <Typography variant="caption">Type</Typography>
                                                <RadioGroup
                                                    row
                                                    name="row-radio-buttons-group"
                                                    value={type ?? typeOptions[0].value}
                                                    onChange={(event, value) => {
                                                        setType(value ?? '');
                                                        setSelectedApprover(null);
                                                        $.set('New Agent Type', value);
                                                    }}
                                                >
                                                    {typeOptions.map((option) => (
                                                        <FormControlLabel
                                                            key={option.value}
                                                            value={option.value}
                                                            control={<Radio />}
                                                            label={option.label}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            </div>
                                            {type === 'US' ? (
                                                <div>
                                                    {!selectedApprover && (
                                                        <Typography variant="caption">New Approver</Typography>
                                                    )}
                                                    <SelectApproverAutocomplete
                                                        context={$}
                                                        selectedApprover={selectedApprover}
                                                        setSelectedApprover={setSelectedApprover}
                                                    />
                                                </div>
                                            ) : null}
                                            {type === 'S' ? (
                                                <div>
                                                    {!selectedApprover && (
                                                        <Typography variant="caption">New Position</Typography>
                                                    )}
                                                    <SelectAgentAutocomplete
                                                        context={$}
                                                        selectedApprover={selectedApprover}
                                                        setSelectedApprover={setSelectedApprover}
                                                        path={'PositionIdSet'}
                                                        filter={(value) => `IdNo eq '01' and SearchTerm eq '${value}'`}
                                                    />
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    onChange={(e) => {
                                                        $.set('Is delegation', e.target.checked);
                                                    }}
                                                    checked={isDelegation ?? false}
                                                />
                                            }
                                            label="Is delegation ?"
                                        />
                                    </div>
                                    {isDelegation && (
                                        <>
                                            <div>
                                                <Typography variant="caption">Delegation From</Typography>
                                                <TextField
                                                    type="date"
                                                    value={
                                                        delegationFrom instanceof Date && !isNaN(delegationFrom)
                                                            ? format(delegationFrom, DATE_FORMAT)
                                                            : ''
                                                    }
                                                    onChange={(event) => {
                                                        $.set(
                                                            'Delegation From',
                                                            parse(event.target.value, DATE_FORMAT, Date.now())
                                                        );
                                                    }}
                                                    InputProps={{
                                                        inputProps: { min: format(Date.now(), DATE_FORMAT) },
                                                    }}
                                                    fullWidth
                                                ></TextField>
                                            </div>
                                            <div>
                                                <Typography variant="caption">Delegation To</Typography>
                                                <TextField
                                                    type="date"
                                                    value={
                                                        delegationTo instanceof Date && !isNaN(delegationTo)
                                                            ? format(delegationTo, DATE_FORMAT)
                                                            : ''
                                                    }
                                                    onChange={(event) => {
                                                        $.set(
                                                            'Delegation To',
                                                            parse(event.target.value, DATE_FORMAT, Date.now())
                                                        );
                                                    }}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: format(delegationTo ?? Date.now(), DATE_FORMAT),
                                                        },
                                                    }}
                                                    fullWidth
                                                ></TextField>
                                            </div>
                                        </>
                                    )}
                                </div>
                            }
                            button={
                                <ConfirmButton
                                    text={isDelegation ? 'Add Delegation' : 'Change Approver'}
                                    onClick={handleConfirm}
                                />
                            }
                            handleCloseDialog={handleClose}
                        />
                    );
                } else {
                    return (
                        <BasePopup
                            title="Delete Approvers"
                            style={{
                                minHeight: '250px',
                                minWidth: '500px',
                            }}
                            content={<Typography variant="subtitle1">Delete all the selected approvers?</Typography>}
                            button={<ConfirmButton text="Delete Approvers" onClick={handleConfirm} />}
                            handleCloseDialog={handleClose}
                        />
                    );
                }
            } else if (showSuccessAlert) {
                const errors = $.get('Mass Change Error Rows') || [];
                let authorizationError = false;
                for (let i = 0; i < errors.length; i++) {
                    if (errors[i].errorStatusMessage.includes('authorization')) {
                        authorizationError = true;
                    }
                }
                const Content = () => {
                    if (errors.length > 0) {
                        const columns = [
                            {
                                field: 'errorStatusCode',
                                headerName: 'Error Status Code',
                                width: 200,
                                sortable: false,
                            },
                            {
                                field: 'errorMessage',
                                headerName: 'Error Message',
                                width: 300,
                                flex: true,
                                sortable: false,
                            },
                        ];
                        return (
                            <BasePopup
                                title={`${
                                    $.get('Mass Change Failed All') ? 'All' : 'Some'
                                } approver could not be changed, error(s) :`}
                                content={
                                    <div>
                                        {authorizationError && (
                                            <Paper
                                                style={{
                                                    marginBottom: '2vh',
                                                    padding: '1vh',
                                                    backgroundColor: '#ffb74d',
                                                }}
                                            >
                                                <Typography variant="caption">
                                                    Approver could not be added as they do not have the SAP PR & EasyBuy
                                                    Business Approver role assigned to their profile.
                                                    <br />
                                                    You can raise a request by following this{' '}
                                                    <a href="https://amigo.nestle.com/LORA/page.axd?RuntimeFormID=fb38c1f7-cda6-4cea-ab42-8cc5a553081f&aeweb_handler=p&aeweb_rp=&wproj=0&MenuID=Portal_IAM_MyIdentity&ContextID=CCC_ITShop_ProductSelection">
                                                        link
                                                    </a>
                                                    .
                                                </Typography>
                                            </Paper>
                                        )}
                                        <Box sx={{ height: 400, width: '100%', overflow: 'scroll' }}>
                                            <DataGrid
                                                rows={errors}
                                                columns={columns}
                                                pageSize={5}
                                                rowsPerPageOptions={[5]}
                                                disableSelectionOnClick
                                                disableColumnMenu={true}
                                            />
                                        </Box>
                                    </div>
                                }
                                button={<ConfirmButton text="Close" onClick={handleClose} />}
                                largeWidth={true}
                                handleCloseDialog={handleClose}
                            />
                        );
                    } else {
                        return <Alert open={true} handleClose={handleClose} />;
                    }
                };
                return <Content />;
            } else if (showErrorAlert) {
                // TODO replace with Show Backend Alert brick call (from relevant lambda) to simplify code
                return <ChangeErrorAlert open={true} handleClose={handleClose} errorMessage={errorMessage} />;
            } else {
                return null;
            }
        };
    }
}

registerBrick('018220b4f477a0ba836e', MassChangeChangeApproverPopup);
